<!--<div class="mat-star-div caret-sign-input small-device-input" *ngIf="!isCompanyUser">-->
  <div class="d-flex">


    <!--<div class="mat-star-div caret-sign-input small-device-input">
    <div>
      <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto">
        <input #regionAutoComplete matInput placeholder="Please Select Region"
               class="company-select-box"
               (input)="onInputRegionChanged($event.target.value)"
               [matAutocomplete]="autoregion"
               [(ngModel)]="region" />
        <mat-autocomplete #autoregion="matAutocomplete" [displayWith]="displayFnAutoRegionComplete">
          <mat-option (onSelectionChange)="onChangeRegion($event)"
                      *ngFor="let item of regionAutoList"
                      [value]="item">
            <span> {{ item.region }}</span>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <mat-icon class="caret-sign-input-icon">keyboard_arrow_down</mat-icon>
  </div>

  <div class="mat-star-div caret-sign-input small-device-input">
    <div>
      <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto">
        <input #districtAutoComplete matInput placeholder="Please Select District"
               class="company-select-box"
               (input)="onInputDistrictChanged($event.target.value)"
               [matAutocomplete]="autodistrict"
               [(ngModel)]="district" />
        <mat-autocomplete #autodistrict="matAutocomplete" [displayWith]="displayFnAutoDistrictComplete">
          <mat-option (onSelectionChange)="onChangeDistrict($event)"
                      *ngFor="let item of districtAutoList"
                      [value]="item">
            <span> {{ item.district }}</span>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <mat-icon class="caret-sign-input-icon">keyboard_arrow_down</mat-icon>
  </div>-->

    <div class="mat-star-div caret-sign-input small-device-input global-company-header">
      <div>
        <div class="header-select-div" fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto" style="position: relative;">
      
          <div class="Header-title">
           Company :
          </div>
          <input #companyAutoComplete matInput placeholder="Please Select Company"
           [formControl]="autoCompleteFormControl" class="company-select-box" 
           (input)="onInputChanged($event.target.value)" [matAutocomplete]="auto" />
          
          <mat-icon class="dropdown-arrow" *ngIf="companyAutocompleteList?.length > 0">arrow_drop_down</mat-icon>
          
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnAutoComplete">
            @for (item of companyAutocompleteList; track item) {
              <mat-option 
              (onSelectionChange)="onChangeCompany($event)"
              [disabled]="isCompanyChanging"
              [value]="item">
              <span> {{ item.companyName }}</span>
              @if(item.isFavourite){
              <mat-icon class="amber-600-fg">star</mat-icon>
              }
              @if(!item.isFavourite){
              <mat-icon class="amber-600-fg">star_border</mat-icon>
              }
            </mat-option>
              }

          </mat-autocomplete>
        </div>
        

        <div
        class="favourite-icon bg-card relative z-49 flex h-16 flex-0 items-center px-1    dark:bg-transparent dark:shadow-none md:px-1 print:hidden"
    >
        <div class="px-1 px-mat-16" >
          <button mat-icon-button matTooltip="Set Favourite Company" class="fav-icon-bg" (click)="setFavouriteCompany();">
            <mat-icon class="amber-600-fg">star</mat-icon>
          </button>
        </div>
        </div>
        <div class="header-entity-wrapper">
          <div class="header-select-div" fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto" style="position: relative;">
            <div class="Header-title-entity">
              Entity :
             </div>
             <input class="Entity-select-box"
             #entityAutoComplete
             matInput
             placeholder="Please Select Entity"
             [formControl]="autoCompleteFormEntity"
             (input)="onInputEntityChanged($event.target.value)"
             [matAutocomplete]="autoEntity" />
            <!-- Dropdown arrow inside the input box -->
            <mat-icon class="dropdown-arrow" *ngIf="entityAutoCompleteList?.length > 0">arrow_drop_down</mat-icon>
          
            <mat-autocomplete #autoEntity="matAutocomplete" [displayWith]="displayFnAutoEntityComplete">
              @for(item of filteredEntityList; track item) {
                <mat-option 
                  (onSelectionChange)="onChangeEntity($event,item)" 
                  [value]="item.text">
                  <span>{{ item.text }}</span>
                </mat-option>
              }
            </mat-autocomplete>
          </div>
          
  
  
          <div class="page-title-wrapper">
            <!-- <p class="form-title-sm text-2xl mb-0"> Entity :</p> -->
            <div class="btn-list-wrapper">
              <button mat-raised-button color="primary" aria-label="boards button" (click)="addOrEditEntity()" class="mr-4">
                <!--<mat-icon class="mr-8">add</mat-icon>-->
                <span class="test">Add New Entity</span>
              </button>
             <button mat-raised-button color="primary" aria-label="boards button" (click)="addOrEditEntity(false)">
          
              <span class="test">Edit</span>
            </button>
            </div>
          </div>
        </div>
          

  
    </div>


  
</div>
 

  </div>
<!-- <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto" *ngIf="isCompanyUser && companyAutocompleteList !== undefined && companyAutocompleteList !== null && companyAutocompleteList.length > 0">
  <span> {{ companyAutocompleteList[0].companyName }}</span>
</div> -->
